function num(a: any, b: any): number {
    return (a !== undefined && a !== null) ? a : (b || 0);
}

export class ChatMensajeDto {
    public id: number = 0;
    public idConversacion: number = 0;
    public rol: string = "user";
    public contenido: string = "";
    public datecreated: string = "";

    constructor(data?: any) {
        if (!data) { return; }
        this.id              = num(data.Id,               data.id);
        this.idConversacion  = num(data.Id_conversacion,  data.id_conversacion);
        this.rol             = data.Rol       || data.rol       || "user";
        this.contenido       = data.Contenido || data.contenido || "";
        this.datecreated     = data.Datecreated || data.datecreated || "";
    }
}
